// extracted by mini-css-extract-plugin
export default {"rootWrapper":"PositionCreateForm_rootWrapper__Jo+Y-","rateWrapper":"PositionCreateForm_rateWrapper__jKYMb"};